import React from 'react';
import {sizes, svgs} from '../../../constants';

import Icon from '../../icon/Icon';
import Link from '../../link/Link';

import styles from '../Markdown.pcss';

const MarkdownLink = (props: {href: string; title: string; children: string[]}) => {
    return (
        <span className={styles.linkWrapper}>
            <Link ariaLabel={props.title || ''} className={styles.link} to={props.href}>
                {props.children}
            </Link>
            <Icon className={styles.linkIcon} icon={svgs.EXTERNAL_LINK_V2} size={sizes.CUSTOM} />
        </span>
    );
};

export default MarkdownLink;
